import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import { Button} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {print} from 'react-icons-kit/fa/print';
import SvgIcon from 'react-icons-kit';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import Help from '../../generics/help';
import { Typeahead } from 'react-bootstrap-typeahead';

const Config = require('../../../config');
var session = sessionStorage.getItem('health_facilities_name');
const style = {
  margin: 7,
};


const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

class Hemovigilance extends Component{
	constructor(props){
		super(props);

		this.openForm = this.openForm.bind(this);
		this.getList = this.getList.bind(this);
		this.setTable = this.setTable.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.print = this.print.bind(this);
		this.searchComponent = this.searchComponent.bind(this);
		this.onSearchComponent = this.onSearchComponent.bind(this);

		var aux_date = new Date();

		this.state = {
			list: [],
			all:'false',
			check_all:false,
			columns:[],
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			unit_number: "",
			component: "",
			code_component_list:[],
			search:"unit",
			unit_number_required:false,
			isLoading:false
		}
	}

	componentDidMount(){

		this.props.waiting.handleShow('Cargando...')
		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=HEMOVIGILANCIA',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => response.json())
      	.then(response => {
      		
        	if(response !== undefined){
          		this.setState({ columns: response });
          		setTimeout(()=>{
					this.getList();
          		}, 500);
          		
        	}
      	});

      	
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

  	onSearch(){
  		setTimeout(()=>{
			this.$el = $(this.el);
			this.$el.DataTable().destroy();
			//this.$el.empty();
		}, 500);

		setTimeout(()=>{
			this.props.waiting.handleShow('Cargando...');
			this.getList();
  		}, 1000);		
  	}

	getList(){
		if(this.state.search == "date"){
			fetch(Config.default.apiGateway.URL+'transfusional_control/?start_date='+this.state.start_date+
				'&end_date='+this.state.end_date+'&show_all='+this.state.all+
				"&health_facilities_id="+sessionStorage.getItem('health_facilities_id'),{
				method:'get',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					
					this.setState({
						list:response
					})	

					setTimeout(()=>{
						this.setTable();

					}, 300);
					
				}
			});
		}else{
			this.props.waiting.handleClose();
		}
	}

	openForm(id){
		this.props.history.push('/transfutional_control/'+id);
		//this.modal_form.handleShow(id);
	}

	setTable(){
		this.props.waiting.handleClose();
		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: '<"toolbar">frtip',
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando..."
			},
			paging:false,
			responsive:true,
			searching: this.state.search === 'date' ? true : false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
		});

		if(this.state.search === 'date'){
			$(".toolbar").html(
				'<input type="checkbox" class="show_all_small" '+(this.state.check_all ? 'checked ' : '')+'/> Ver todos'
			);
			$(document).off('click').on('click', '.show_all_small', (e)=>{
				this.setState({
					all: e.target.checked ? 'true' : 'false',
					check_all: e.target.checked ? true : false
				});
				
				setTimeout(()=>{
					this.$el = $(this.el);
					this.$el.DataTable().destroy();
					this.props.waiting.handleShow('Cargando...');
					this.getList();
				}, 500);
				
			})
		}else{
			$(document).off('click').on('click', '.show_all_small', (e)=>{
				this.setState({
					all: e.target.checked ? 'true' : 'false',
					check_all: e.target.checked ? true : false
				});
				
				setTimeout(()=>{
					this.$el = $(this.el);
					this.props.waiting.handleShow('Cargando...');
				}, 500);
				
			})
		}
		
		
		
		$('.dataTables_filter').css('float', 'left');
		$('.dataTables_wrapper .dt-buttons').css('float', 'right')
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});

		if(e.target.name === "search"){
			setTimeout(()=>{
				this.$el = $(this.el);
				this.$el.DataTable().destroy();
				//this.$el.empty();
				this.setState({
					list:[],
					unit_number:"",
					code_component_list:[]
				});
				this.setTable();
			}, 1000);


		}
	}

	async print(id){

		//this.props.waiting.handleShow('Imprimiendo...');
		var type = await this.props.getDocumentType('control_hemovigilance');

		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = "control_hemovigilance";
		obj.nEtiqueta = [0];
	
		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.props.waiting.handleClose();
			this.setState({ show: false});
		}else{
			this.props.waiting.handleClose();
		}
		
		
	}
	
	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			if(e.target.value !== ""){
				this.setState({unit_number_required: false});
				fetch(Config.default.apiGateway.URL+'unit_delivered/by_unit_number?unit_number='+e.target.value+
					'&hf_id='+sessionStorage.getItem('health_facilities_id'), {
					method: 'get',
					headers: new Headers({
						'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					if(res.ok){
						return res.json();
					}else{
						res.text().then(msg=>{
							swal("Error", msg, 'error')
						});

						document.getElementById('unit_number').focus();
					}
				})
				.then(response=>{
					if(response !== undefined){
						var codes = [];
						response.map(res => 
							codes.push({
								label: res.code+' '+res.component_number,
								id: res.unit_delivered_id
							})
						)

						this.setState({code_component_list: codes});
						this._typeahead.getInstance().focus();
					}

				})
			}else{
				this.setState({unit_number_required: true});
			}
			

		}
	}

	onSearchComponent(e){
		if(e.length > 0){
			this.props.waiting.handleShow('Cargando...');
			setTimeout(()=>{
				this.props.waiting.handleShow('Cargando...');
				this.$el = $(this.el);
				this.$el.DataTable().destroy();
				//this.$el.empty();
			}, 500);

			fetch(Config.default.apiGateway.URL+'transfusional_control/?unit_delivered_id='+e[0].id, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					console.log(response);
					this.setState({
						list:response
					})

					setTimeout(()=>{
						this.props.waiting.handleClose();
						this.setTable();
					}, 1000);
					
				}

			})
		}
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Hemovigilancia
					</h5>
				</div>
				<Help 
            		{...this.props}
	                menu={"help_patients"} 
	                submenu={"help_hemo_watch"}  />

				
				<div className="form-group col-xs-12">
					<div className="col-xs-12 col-sm-2 form-group">
						<span className="span-min">Buscar por:</span>
						<select className="form-control" name="search" id="search" value={this.state.search}
							onChange={this.handleChange} required>
							<option value="date">Fecha</option>
							<option value="unit">Unidad</option>
						</select>
					</div>
					{this.state.search === 'date' ?
						<div>
							<div className="col-xs-12 col-sm-2 form-group" style={{paddingLeft:"0"}}>
								<span className="span-min">Fecha Desde</span>
								<input type="date" className="form-control hour-input" name="start_date" id="start_date"
									value={this.state.start_date} onChange={this.handleChange} required />
							</div>
							<div className="col-xs-12 col-sm-2 form-group" style={{paddingRight:"0"}}>
								<span className="span-min">Fecha Hasta</span>
								<input type="date" className="form-control hour-input" name="end_date" id="end_date"
									value={this.state.end_date} onChange={this.handleChange} required />
							</div>
						</div>
					:
						<div>
							<div className="col-xs-12 col-sm-2 form-group" style={{paddingLeft:"0"}}>
								<span className="span-min">Unidad</span>
								<input className={this.state.unit_number_required ? "form-control error" : "form-control"} type="text" 
										id = "unit_number" name="unit_number" onKeyPress={(e) => this.searchComponent(e)} onChange={this.handleChange}
										value={this.state.unit_number || ""} />
							</div>
							<div className="col-xs-12 col-sm-2 form-group" style={{paddingLeft:"0"}}>
								<span className="span-min">Código componente</span>
								<Typeahead
									/*{...this.state}*/
									labelKey={(option) => `${option.label}`}
									minLength={0}
									options={this.state.code_component_list.length > 0 ? this.state.code_component_list : []}
									onChange={this.onSearchComponent}	
									inputProps={{
										name:"code_component",
										id:"code_component",
										autoComplete:'off'
									}}
									id="codeComponent"
									autoComplete="off"
									isLoading={this.state.isLoading}
									ref={ref => this._typeahead = ref}
									delay={600}
									paginationText="Mostrar mas resultados..."
								/>
							</div>
						</div>
					}
					{this.state.search === 'date'  &&
						<div className="col-xs-12 col-sm-1">
							<button className="btn btn-info" style={{marginTop:'18px'}} onClick={this.onSearch}>Buscar</button>
						</div>
					}
				</div>

				<div className="col-xs-12 form-group">
					<table className="table table-responsive table-hover" ref={el => this.el = el}>
						<thead>
							<tr>
								<th hidden={this.showColumn('UNIT_NUMBER')} style={{width:'90px', textAlign:'left'}}>No. Unidad</th>
								<th hidden={this.showColumn('COMPONENT')} style={{width:'80px', textAlign:'left'}}>Componente</th>
								<th hidden={this.showColumn('SAMPLE')} style={{width:'80px', textAlign:'left'}}>No. Muestra</th>
								<th hidden={this.showColumn('HEALTH_SERVICE')} style={{width:'130px', textAlign:'left'}}>Servicio</th>
								<th hidden={this.showColumn('HEALTH_FACILITY')} style={{width:'13px', textAlign:'left'}}>Hospital</th>
								<th hidden={this.showColumn('PATIENT')} style={{width:'130px', textAlign:'left'}}>Paciente</th>
								<th hidden={this.showColumn('DATE_SEND')} style={{width:'100px', textAlign:'left'}}>Fecha Envio</th>
								<th hidden={this.showColumn('HOUR_SEND')} style={{width:'100px', textAlign:'left'}}>Hora Envio</th>
								<th hidden={this.showColumn('CONTROLS')} style={{width:'50px', textAlign:'left'}}></th>
							</tr>
						</thead>
						<tbody>
							{this.state.list.map((l, i)=>(
								<tr key={i}>
									<td hidden={this.showColumn('UNIT_NUMBER')} style={{width:'100px'}}>{l.unit_number}</td>
									<td hidden={this.showColumn('COMPONENT')} style={{width:'90px'}}>{l.component+' '+l.component_number}</td>
									<td hidden={this.showColumn('SAMPLE')} style={{width:'90px'}}>{l.sample_number}</td>
									<td hidden={this.showColumn('HEALTH_SERVICE')} style={{width:'90px'}}>{l.service}</td>
									<td hidden={this.showColumn('HEALTH_FACILITY')} style={{width:'90px'}}>{l.hospital}</td>
									<td hidden={this.showColumn('PATIENT')} style={{width:'90px'}}>{l.patient}</td>
									<td hidden={this.showColumn('DATE_SEND')} style={{width:'90px'}}>{moment(l.sended).format('DD/MM/YYYY')}</td>
									<td hidden={this.showColumn('HOUR_SEND')} style={{width:'90px'}}>{moment(l.sended).format('HH:mm')}</td>
									<td hidden={this.showColumn('CONTROLS')} style={{width:'90px'}}>
										<button className="btn btn-info" title="Imprimir" type="button" 
					                     	style={{marginRight:'8px'}}
											disabled={!l.flag_during && !l.flag_end && !l.flag_start}
											onClick={(e)=>this.print(l.unit_id)}>
					                        <SvgIcon icon={print}/>
					                     </button>

										<button className="btn" title="Editar" 
											style={l.flag_during && l.flag_end && l.flag_start ?
													{background:'rgb(var(--primary))', marginRight:'5px', color:'white'}
												: !l.flag_during && !l.flag_end && !l.flag_start ?
													{background:'#a39f9f', marginRight:'5px', color:'white'}
												:{background:'rgba(var(--primary), 0.5)',marginRight:"5px", color:'white'}} 
											onClick={this.openForm.bind(this, l.unit_id)}>
											<SvgIcon icon={pencil2} />
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

			</div>
		)
	}
}

export default translate('translations')(Hemovigilance);